import * as paths from "./paths";

export const authRoutes: ModuleRoute[] = [paths.login, paths.register];

export const homeRoutes: ModuleRoute[] = [paths.home];

export const wlistRoutes: ModuleRoute[] = [paths.watchlist];

export const dashboardRoutes: ModuleRoute[] = [paths.dashboard];

export const dectRoutes: ModuleRoute[] = [paths.dectOpp];

const routes: ModuleRoute[] = [...authRoutes, ...homeRoutes, ...dashboardRoutes, ...dectRoutes, ...wlistRoutes];

export default routes;

export { paths };
